/**
 * @file 聚合页
 * @author wangzhuang
 * */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Modal} from 'antd-mobile';
import {
    fetchActivityGetService,
    fetchInstanceGetInstance,
    fetchApimealPay,
    fetchRealName
} from '../../actions/buyAction';

import './index.less';

class Buy extends Component {
    static propTypes = {
        userLoginstate: PropTypes.object,
        activityGetService: PropTypes.object,
        instanceGetinstance: PropTypes.object,
        fetchApimealPay: PropTypes.func,
        fetchActivityGetService: PropTypes.func,
        fetchInstanceGetInstance: PropTypes.func
    };

    constructor(props, context) {
        super(props, context);
        // let reg = new RegExp('(localhost|127.0.0.1|test.anquan.baidu.com|cq02-security-dev01.cq02.baidu.com)');
        // let res = reg.test(location.host); // 判断是否为测试线
        this.state = {
            modal1: false,
            modal2: false,
            toast: false,
            toastTitle: '',
            lookUrl: '',
            authType: 0, // 是不是企业认证
            // loginUrl: res
            //     ? `http://wappass.qatest.baidu.com?tpl=spu&subpro=spuuser&u=${location.href}`
            //     : `http://wappass.baidu.com?tpl=spu&subpro=spuuser&u=${location.href}`
            loginUrl: this.loginUrl()
        };
    }

    componentWillMount() {
        if (this.isPC()) {
            location.href = `/buy${location.search}`;
        }
    }

    componentWillReceiveProps(nextProps) {
        let nextUser = nextProps.userLoginstate;
        if (!Object.is(nextUser, this.props.userLoginstate)) {
            if (nextUser.status === 0) {
                this.props.fetchInstanceGetInstance().then(data => {
                    let key = Object.keys(data.data.data)[0];
                    this.props.fetchActivityGetService({'instance_id': key});
                });
            } else {
                this.props.fetchActivityGetService();
            }
        }
    }

    onClose = key => () => {
        this.setState({
            [key]: false
        });
    };

    hmt() {
        try {
            window._hmt.push(['_trackEvent', 'gmplugin', 'use', 'mobile']);
        }
        catch (e) {
            return;
        }
    }

    render() {
        const {activityGetService, instanceGetinstance, userLoginstate} = this.props;
        let {modal1, modal2, loginUrl, lookUrl} = this.state;

        return (
            <div className={'saas-buy'}>
                <div className="saas-buy-banner" />
                <div className="saas-buy-hint">
                    登录账号一键下单，热门产品免费试用
                </div>
                <div className="saas-buy-pro">
                    {!this.isEmptyobj(activityGetService)
                        ? activityGetService.data.map((item, index) => {
                            return <div
                                className="saas-buy-item"
                                key={index}
                            >
                                <div className="saas-buy-name">
                                    <span className={item.is_hot ? 'hot' : null}>{item.service_name}</span>
                                    {item.is_hot ? <i className="saas-buy-hot" /> : null}
                                </div>
                                <div className="saas-buy-text">
                                    {item.service_desc}
                                </div>
                                <div className="saas-buy-info">
                                    <a href={item.url} target="_blank">查看详情 <i /></a>
                                </div>
                                <div className="saas-buy-item-hint">
                                    <span>免费体验时长：</span>
                                    <span>{item.is_buy ? '-' : item.capacity}</span>
                                </div>
                                <div
                                    className={item.is_buy ? 'saas-buy-btn disable' : 'saas-buy-btn'}
                                    onClick={() => {
                                        if (item.is_buy) {
                                            return false;
                                        }

                                        if (!this.isEmptyobj(activityGetService) && userLoginstate.status === 0) {
                                            let key = Object.keys(instanceGetinstance.data)[0];
                                            let json = {
                                                'instance_id': key,
                                                'service_id': item.service_id,
                                                'meal_id': item.meal_id
                                            };

                                            this.props.fetchApimealPay(json).then(data => {
                                                if (data.data.status === 0) { // 购买成功
                                                    this.hmt();
                                                    this.props.fetchActivityGetService({'instance_id': key});
                                                    this.setState({
                                                        modal2: true,
                                                        lookUrl: item.url
                                                    });
                                                } else if (data.data.status === 404008) { // 未实名
                                                    fetchRealName({'instance_id': key}).then(res => {
                                                        this.setState({
                                                            modal1: true,
                                                            authType: res && res.data && res.data['auth_type'] || 0
                                                        });
                                                    });
                                                } else if (data.data.status === 404008) { // 未登录
                                                    location.href = loginUrl;
                                                }
                                                else if (data.data.description) {
                                                    this.setState({
                                                        toastTitle: data.data.description,
                                                        toast: true
                                                    });
                                                }
                                            });
                                        } else {
                                            location.href = loginUrl;
                                        }
                                    }}

                                >
                                    {item.is_buy ? '已领取' : '免费领取'}
                                </div>
                            </div>;
                        })
                        : null
                    }
                </div>

                <Modal
                    visible={modal1}
                    transparent
                    maskClosable={true}
                    className={'saas-attest'}
                    onClose={this.onClose('modal1')}
                >
                    <div className={'hint'}>
                        您的账号还没有认证，认证后才能购买哦！
                    </div>
                    <a
                        className={'saas-buy-btn'}
                        href={this.state.authType === 0
                            ? this.userCenterUrl()
                            : '/console/#/attestation'
                        }
                        // target={'_blank'}
                        onClick={() => {
                            this.setState({
                                modal1: false
                            });
                        }}
                    >
                        去认证
                    </a>
                </Modal>

                <Modal
                    visible={modal2}
                    transparent
                    maskClosable={false}
                    className={'saas-attest'}
                    onClose={this.onClose('modal2')}
                >
                    <div className={'hint'}>
                        购买成功，可前往控制台查看使用说明
                    </div>
                    <div className={'operate'}>
                        <a
                            className={'saas-buy-btn hint-btn'}
                            href={lookUrl}
                            target={'_blank'}
                            onClick={() => {
                                this.setState({
                                    modal2: false
                                });
                            }}
                        >
                            去控制台
                        </a>
                        <div
                            className={'saas-buy-btn'}
                            onClick={() => {
                                this.setState({
                                    modal2: false
                                });
                            }}
                        >
                            继续购买
                        </div>
                    </div>
                </Modal>

                <Modal
                    visible={this.state.toast}
                    transparent
                    maskClosable={false}
                    wrapClassName="spu-modal-confirm"
                    className={'saas-attest'}
                    onClose={this.onClose('modal2')}
                >
                    <div className={'hint'}>
                        {this.state.toastTitle}
                    </div>
                    <div className={'operate'}>
                        <a
                            className={'saas-buy-btn'}
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                    toast: false,
                                    toastTitle: ''
                                });
                            }}
                        >
                            关闭
                        </a>
                    </div>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        userLoginstate: state.userLoginstate,
        activityGetService: state.activityGetService,
        instanceGetinstance: state.instanceGetinstance
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchApimealPay: obj => fetchApimealPay(dispatch, obj),
        fetchActivityGetService: obj => fetchActivityGetService(dispatch, obj),
        fetchInstanceGetInstance: () => fetchInstanceGetInstance(dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Buy);



// WEBPACK FOOTER //
// ./src/containers/buy/index.js